export const repeatOptions = [
  {
    title: "1分",
    value: 1,
  },
  {
    title: "1分半",
    value: 1.5,
  },
  {
    title: "2分",
    value: 2,
  },
  {
    title: "3分",
    value: 3,
  },
  {
    title: "5分",
    value: 5,
  },
  {
    title: "10分",
    value: 10,
  },
  {
    title: "30分",
    value: 30,
  },
  {
    title: "60分",
    value: 60,
  },
];

export const responseOptions = [
  {
    title: "3秒",
    value: 3,
  },
  {
    title: "5秒",
    value: 5,
  },
  {
    title: "10秒",
    value: 10,
  },
  {
    title: "15秒",
    value: 15,
  },
  {
    title: "20秒",
    value: 20,
  },
];

export const alertTimeOptions = [
  {
    title: "5分",
    value: 5,
  },
  {
    title: "10分",
    value: 10,
  },
  {
    title: "15分",
    value: 15,
  },
  {
    title: "30分",
    value: 30,
  },
  {
    title: "60分",
    value: 60,
  },
  {
    title: "90分",
    value: 90,
  },
  {
    title: "120分",
    value: 120,
  },
];
